import type { LucideIcon } from 'lucide-react-native';

import { GlassIconButton, useLiquidGlass } from '@/components/ui/glass';

type PreviewActionButtonProps = {
  label: string;
  icon: LucideIcon;
  onPress: () => void;
};

/**
 * A round icon control floating over the image preview. Liquid Glass on iOS 26
 * and, elsewhere, the white disc the other sheets' header buttons use. The
 * label is spoken, since the button shows only its icon.
 *
 * The picture behind can be any brightness, so the glass is always the dark
 * kind with a white icon. Themed colors would pair a light icon with pale glass
 * over a white screenshot in dark mode. The opaque fallback brings its own
 * background, so its theme colors stay legible.
 */
export function PreviewActionButton({ label, icon, onPress }: PreviewActionButtonProps) {
  const hasGlass = useLiquidGlass();

  return (
    <GlassIconButton
      icon={icon}
      accessibilityLabel={label}
      onPress={onPress}
      tone="dark"
      iconClassName={hasGlass ? 'h-5 w-5 text-typography-white' : 'h-5 w-5 text-typography-900'}
      fallbackClassName="bg-background-0 shadow-soft-1 web:hover:bg-background-100"
    />
  );
}
